<fl-blank-layout-container [controls$]="controls$" [title$]="title$">
  <router-outlet></router-outlet>
</fl-blank-layout-container>
